var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLatestToEarliest(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Latest_Earliest_Icons",
    "data-name": "Latest Earliest Icons",
    transform: "translate(-1194 -275)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Latest_to_Earliest_",
    "data-name": "Latest to Earliest ",
    transform: "translate(3041 3861)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Base",
    transform: "translate(-1847 -3586)",
    fill: "#2a374e",
    stroke: "#707070",
    strokeWidth: 1,
    opacity: 0
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 17,
    height: 17,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Latest_to_Earliest",
    "data-name": "Latest to Earliest",
    transform: "translate(-1845 -3584)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_289",
    "data-name": "Group 289",
    transform: "translate(7.936)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_288",
    "data-name": "Group 288",
    transform: "translate(6.537 13.5) rotate(180)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1479",
    "data-name": "Path 1479",
    d: "M269.348,9.487l-2,2V0H266.3V11.486l-2-2-.744.744,3.269,3.269,3.269-3.269Z",
    transform: "translate(-263.555)",
    fill: "#2a374e"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_778",
    "data-name": "Group 778",
    transform: "translate(0.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_288-2",
    "data-name": "Group 288"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1479-2",
    "data-name": "Path 1479",
    d: "M269.348,9.487l-2,2V0H266.3V11.486l-2-2-.744.744,3.269,3.269,3.269-3.269Z",
    transform: "translate(-263.555)",
    fill: "#2a374e"
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLatestToEarliest);
export default __webpack_public_path__ + "static/media/latestToEarliest.b84a5982063e6f8bc9701c560fbd31ff.svg";
export { ForwardRef as ReactComponent };